import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { NetzbetreiberDetailComponent } from '../netzbetreiber-detail/netzbetreiber-detail.component';

@Component({
    selector: 'tnb-netzbetreiber-page',
    templateUrl: './netzbetreiber-page.component.html',
    styleUrls: [
        './netzbetreiber-page.component.scss',
    ],
    standalone: false,
})
export class NetzbetreiberPageComponent {
    private westnetzSidenavService = inject(WestnetzSidenavService);
    private activateRoute = inject(ActivatedRoute);

    constructor() {

        this.activateRoute.queryParams.subscribe(params => {
            if (params && (params.stadtwerkeId || params.createnew)) {
                this.westnetzSidenavService.openRightnav(NetzbetreiberDetailComponent);
            }
        });
    }

}
